/**
 * Textos (`es`) del tall «evidence» de Qualitat i APPCC (OBR-171). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const evidenceEs = {
  'backoffice.qualityEvidence': {
    // ── Pantalla ──────────────────────────────────────────────────────────────────────────
    subtitle:
      'Genera el dosier con los registros de calidad de un período, listo para mostrarlo en una inspección.',
    periodTitle: 'Período',
    fromLabel: 'Desde el',
    toLabel: 'Hasta el',
    periodIssue_from_invalid: 'La fecha inicial no es válida.',
    periodIssue_to_invalid: 'La fecha final no es válida.',
    periodIssue_from_after_to: 'La fecha inicial no puede ser posterior a la final.',
    blocksTitle: 'Qué se incluye',
    blockHint_homologation:
      'Cada proveedor con su estado, los cambios de estado del período y los documentos (registro sanitario, certificados).',
    blockHint_receptionControls:
      'Las líneas recibidas en albaranes confirmados, con temperatura, envasado, etiquetado, decisión y quién lo registró.',
    blockHint_selfChecks:
      'Los autocontroles hechos (quién, cuándo y resultado, con los valores fuera de rango) y los que tocaban y no se han hecho.',
    blockHint_nonConformities:
      'Las no conformidades abiertas en el período con sus acciones correctoras y su historial.',
    blockHint_training:
      'Cada manipulador con sus formaciones (tema, fecha, entidad y caducidad) y su estado.',
    noBlockSelected: 'Marca al menos un bloque para poder descargar.',
    downloadPdf: 'Descargar el PDF',
    downloadExcel: 'Descargar el Excel',
    preparing: 'Preparando el archivo…',
    downloadError: 'No se ha podido generar el archivo: {{message}}',
    brandingError:
      'No se ha podido leer la identidad del obrador (nombre, logotipo, registro sanitario): {{message}}',
    previewTitle: 'Registros del período',
    previewLoading: 'Leyendo los registros…',
    previewUnavailable: 'No se ha podido leer: {{message}}',
    retry: 'Vuelve a intentarlo',
    footnote:
      'Los datos se leen en el momento de descargar. Esta pantalla solo consulta: no modifica ningún registro.',

    // ── Documento (PDF y Excel) ───────────────────────────────────────────────────────────
    documentTitle: 'Evidencias para inspección',
    period: 'Período',
    generatedOn: 'Generado el',
    generatedBy: 'Generado por',
    registry: 'Registro sanitario',
    summaryTitle: 'Resumen',
    colBlock: 'Bloque',
    colIndicator: 'Indicador',
    colValue: 'Valor',
    emptyBlock: 'Ningún registro en este período.',
    unavailableBlock:
      'Este bloque no se ha podido leer al generar el documento. No significa que no haya registros.',
    emptyEvents: 'Ningún cambio de estado en este período.',
    emptyDocuments: 'Ningún documento registrado.',
    emptyMissed: 'Ningún autocontrol sin hacer.',
    emptyRecords: 'Ningún autocontrol hecho en este período.',
    emptyActions: 'Ninguna acción correctora.',
    emptyNcEvents: 'Ningún evento.',
    pageOf: 'Página {{page}} de {{total}}',
    periodRange: '{{from}} – {{to}}',
    valuePhoto: 'foto adjunta',
    flagOutOfRange: 'fuera de rango',
    flagExpired: 'caducado',
    flagExpiredFeminine: 'caducada',
    noExpiry: 'No caduca',
    rangeBoth: '{{min}} – {{max}}',
    rangeMin: 'mín. {{value}}',
    rangeMax: 'máx. {{value}}',

    // Tablas
    tableSuppliers: 'Proveedores y estado de homologación',
    tableHomologationEvents: 'Cambios de estado en el período',
    tableDocuments: 'Documentos de los proveedores',
    tableReceptionLines: 'Líneas recibidas con su control',
    tableRecords: 'Autocontroles hechos',
    tableMissed: 'Autocontroles sin hacer',
    tableNonConformities: 'No conformidades',
    tableActions: 'Acciones correctoras',
    tableNcEvents: 'Historial de las no conformidades',
    tableTrainings: 'Formaciones registradas',

    // Columnas
    colSupplier: 'Proveedor',
    colCode: 'Código',
    colStatus: 'Estado',
    colStatusAt: 'Fecha y hora',
    colResponsible: 'Responsable',
    colNotes: 'Observaciones',
    colChangedAt: 'Fecha y hora',
    colFrom: 'De',
    colTo: 'A',
    colReason: 'Motivo',
    colBy: 'Hecho por',
    colDocType: 'Tipo',
    colDocName: 'Documento',
    colDocNumber: 'Número',
    colIssuedOn: 'Emisión',
    colExpiresOn: 'Caducidad',
    colReceptionDate: 'Fecha',
    colReceptionNumber: 'Albarán',
    colArticle: 'Artículo',
    colInternalLot: 'Lote interno',
    colSupplierLot: 'Lote del proveedor',
    colQuantity: 'Cantidad',
    colUnit: 'Unidad',
    colTemperature: 'Temp. (ºC)',
    colRange: 'Rango (ºC)',
    colTemperatureCheck: 'Control de temperatura',
    colPackaging: 'Envasado',
    colLabeling: 'Etiquetado',
    colOutcome: 'Resultado',
    colRecordedBy: 'Registrado por',
    colRecordedAt: 'Fecha y hora del control',
    colTemplate: 'Autocontrol',
    colFrequency: 'Frecuencia',
    colPeriodKey: 'Período',
    colPerformedAt: 'Fecha y hora',
    colResult: 'Resultado',
    colValues: 'Valores',
    colNcCode: 'Código',
    colOrigin: 'Origen',
    colOpenedAt: 'Fecha y hora de apertura',
    colReportedBy: 'Abierta por',
    colDescription: 'Descripción',
    colClosedAt: 'Cierre',
    colClosedBy: 'Cerrada por',
    colClosingNote: 'Nota de cierre',
    colNc: 'NC',
    colAction: 'Acción',
    colDueOn: 'Plazo',
    colVerification: 'Verificación',
    colVerifiedBy: 'Verificada por',
    colEvent: 'Evento',
    colNote: 'Nota',
    colWorker: 'Persona',
    colTopic: 'Tema',
    colTrainedOn: 'Fecha de la formación',
    colProvider: 'Entidad formadora',

    // ── Familias de valores ───────────────────────────────────────────────────────────────
    block_homologation: 'Homologación de proveedores',
    block_receptionControls: 'Controles en la recepción',
    block_selfChecks: 'Autocontroles',
    block_nonConformities: 'No conformidades y acciones correctoras',
    block_training: 'Formación de los manipuladores',

    metric_suppliers: 'Proveedores',
    metric_suppliersApproved: 'Homologados',
    metric_suppliersNotApproved: 'No homologados (pendientes, no homologados o suspendidos)',
    metric_homologationEvents: 'Cambios de estado en el período',
    metric_documents: 'Documentos',
    metric_documentsExpired: 'Documentos caducados',
    metric_lines: 'Líneas recibidas',
    metric_linesControlled: 'Con control registrado',
    metric_linesNotControlled: 'Sin control registrado',
    metric_linesTemperatureOut: 'Temperatura fuera de rango',
    metric_linesRejected: 'Rechazadas',
    metric_records: 'Autocontroles hechos',
    metric_recordsFailed: 'Con resultado KO',
    metric_missed: 'Autocontroles sin hacer',
    metric_nonConformities: 'No conformidades abiertas en el período',
    metric_nonConformitiesOpen: 'Aún abiertas o en curso',
    metric_nonConformitiesClosed: 'Cerradas',
    metric_actions: 'Acciones correctoras',
    metric_actionsOpen: 'Acciones sin cerrar',
    metric_workers: 'Manipuladores',
    metric_workersValid: 'Con formación vigente',
    metric_workersExpiring: 'Con formación que caduca pronto',
    metric_workersExpired: 'Con formación caducada',
    metric_workersMissing: 'Sin formación',

    homologationStatus_pending: 'Pendiente',
    homologationStatus_approved: 'Homologado',
    homologationStatus_not_approved: 'No homologado',
    homologationStatus_suspended: 'Suspendido',

    documentType_sanitary_registry: 'Registro sanitario',
    documentType_certificate: 'Certificado',

    checkResult_ok: 'OK',
    checkResult_ko: 'KO',

    qcDecision_accepted: 'Aceptado',
    qcDecision_accepted_with_incident: 'Aceptado con incidencia',
    qcDecision_rejected: 'Rechazado',

    outcome_not_controlled: 'Sin control registrado',
    outcome_accepted: 'Aceptado',
    outcome_accepted_with_incident: 'Aceptado con incidencia',
    outcome_rejected: 'Rechazado',
    outcome_undecided: 'Pendiente de decidir',

    temperatureStatus_not_measured: 'No medida',
    temperatureStatus_no_range: 'Sin rango de referencia',
    temperatureStatus_ok: 'Dentro del rango',
    temperatureStatus_out_of_range: 'Fuera de rango',

    kind_cleaning: 'Limpieza y desinfección',
    kind_temperature: 'Temperaturas',
    kind_pests: 'Control de plagas',
    kind_custom: 'Otros',

    frequency_daily: 'Diaria',
    frequency_weekly: 'Semanal',
    frequency_monthly: 'Mensual',

    ncOrigin_reception: 'Recepción',
    ncOrigin_self_check: 'Autocontrol',
    ncOrigin_production: 'Producción',
    ncOrigin_manual: 'Manual',
    ncOrigin_other: 'Otros',

    ncStatus_open: 'Abierta',
    ncStatus_in_progress: 'En curso',
    ncStatus_closed: 'Cerrada',

    actionStatus_open: 'Abierta',
    actionStatus_in_progress: 'En curso',
    actionStatus_closed: 'Cerrada',

    ncEvent_created: 'Creada',
    ncEvent_status_changed: 'Cambio de estado',
    ncEvent_action_added: 'Acción añadida',
    ncEvent_action_updated: 'Acción actualizada',
    ncEvent_closed: 'Cerrada',
    ncEvent_reopened: 'Reabierta',

    trainingStatus_valid: 'Vigente',
    trainingStatus_expiring: 'Caduca pronto',
    trainingStatus_expired: 'Caducada',
    trainingStatus_missing: 'Sin formación',

    trainingTopic_food_handler: 'Manipulador de alimentos',
    trainingTopic_allergens: 'Alérgenos',
    trainingTopic_other: 'Otros',

    // Resumen del detalle de una NC automática (los mismos motivos que `ncDetailSummary`)
    ncSummary_reasonTemperatureRange:
      'Temperatura {{temperature}} ºC, fuera del rango {{min}} a {{max}} ºC',
    ncSummary_reasonTemperatureAbove:
      'Temperatura {{temperature}} ºC, por encima del máximo ({{max}} ºC)',
    ncSummary_reasonTemperatureBelow:
      'Temperatura {{temperature}} ºC, por debajo del mínimo ({{min}} ºC)',
    ncSummary_reasonTemperature: 'Temperatura {{temperature}} ºC fuera de rango',
    ncSummary_reasonTemperatureUnknown: 'Temperatura fuera de rango',
    ncSummary_reasonPackagingKo: 'Envasado no conforme',
    ncSummary_reasonLabelingKo: 'Etiquetado no conforme',
    ncSummary_reasonDecisionRejected: 'Línea rechazada en el control de recepción',
    ncSummary_reasonDecisionAcceptedWithIncident: 'Línea aceptada con incidencia',
    ncSummary_reasonSelfCheckFailed: 'Autocontrol con resultado KO',
    ncSummary_reasonUnknown: 'Motivo: {{code}}',
    ncSummary_selfCheckFailedRange: '{{label}}: {{value}} (rango {{min}} a {{max}})',
    ncSummary_selfCheckFailedBelowMin: '{{label}}: {{value}} (mínimo {{min}})',
    ncSummary_selfCheckFailedAboveMax: '{{label}}: {{value}} (máximo {{max}})',
    ncSummary_selfCheckFailedValue: '{{label}}: {{value}}',
    ncSummary_selfCheckFailedKo: '{{label}}: KO',
    ncSummary_selfCheckFailedUnnamed: 'Campo del autocontrol que ha fallado',
  },
} as const;
